import store from "../store";
import { updateUserActiveSessionDelta } from "../store/actions";
import { coordinatedRefresh } from "./refreshCoordinator";

const DEFAULT_TOKEN_EXPIRY_SECONDS = 7200;

let refreshTimer = null;

export const scheduleTokenRefresh = (expiresInSeconds) => {
  cancelTokenRefresh();

  // Redis mode: backend handles session extension via middleware on each API call
  // Skip proactive refresh — only needed in legacy mode when tokens are client-side
  const isRedisMode = store.getState()?.sessionReducer?.activeSession?.activeSession?.isRedisMode;
  if (isRedisMode) {
    return;
  }

  const delaySeconds = (expiresInSeconds || DEFAULT_TOKEN_EXPIRY_SECONDS) * 0.9;
  refreshTimer = setTimeout(async () => {
    const refreshToken = store.getState()?.sessionReducer?.activeSession?.activeSession?.refreshToken;
    try {
      const { access_token, refresh_token, id_token, expires_in } = await coordinatedRefresh(refreshToken);
      store.dispatch(
        updateUserActiveSessionDelta({
          sessionToken: access_token,
          refreshToken: refresh_token,
          idToken: id_token
        })
      );
      scheduleTokenRefresh(expires_in || DEFAULT_TOKEN_EXPIRY_SECONDS);
    } catch (error) {
      console.error("[proactiveTokenRefresh] Token refresh failed — axiosInterceptor will handle redirect on next API call:", error?.message);
    }
  }, delaySeconds * 1000);
};

export const cancelTokenRefresh = () => {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
};
